import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlueConfigurationService } from './glue-configuration.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EGlueResource } from '../configurations/common';
import { ISdmIbComponents } from '../models/catalog.models';

@Injectable({
  providedIn: 'root',
})
export class SdmIbComponentsService {
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly glueConfiguration: GlueConfigurationService = inject(GlueConfigurationService);

  glueUrl: string = this.glueConfiguration.getEndpointUrl();
  localStorage: Storage = globalThis.localStorage;

  private static handleError(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }

  getSdmIbComponents(functionalLocation: string): Observable<ISdmIbComponents> {
    const navigationBarUrl: string = this.glueUrl + `/${EGlueResource.SDM_IB_COMPONENTS}?functional-location=${functionalLocation}`;
    return this.httpClient.get<ISdmIbComponents>(navigationBarUrl)
      .pipe(catchError(SdmIbComponentsService.handleError));
  }
}
